module.exports = __webpack_public_path__ + "static/media/shower.9259a865.svg";